/**
 * ContextInfluenceBadge.jsx — Standardized "Context: <mode>" pill.
 *
 * Use everywhere we show context state at a glance (Analysis header,
 * Overview, PeopleLab metadata strip, Reliability assumptions).
 *
 * Pair with <ContextInfluencePanel /> when you need the full breakdown
 * (org context y/n, doc count, web claims, exposure %).
 */
import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';
import { CONTEXT_MODE_LABELS, CONTEXT_MODE_HELP } from '../../lib/metricLabels';

const MODE_TONE = {
  standard: 'bg-slate-50 text-slate-700 border-slate-200',
  light: 'bg-blue-50 text-blue-700 border-blue-200',
  none: 'bg-zinc-50 text-zinc-700 border-zinc-200',
};

export function ContextInfluenceBadge({ mode = 'standard', maxChars = null, className, testId = 'context-influence-badge' }) {
  const label = CONTEXT_MODE_LABELS[mode] || CONTEXT_MODE_LABELS.standard;
  const help = CONTEXT_MODE_HELP[mode] || CONTEXT_MODE_HELP.standard;
  const tone = MODE_TONE[mode] || MODE_TONE.standard;
  const tooltip = maxChars != null ? `${help} · Max ${maxChars} chars.` : help;

  return (
    <Badge
      variant="outline"
      className={cn('border px-2 py-0.5 font-medium text-[11px]', tone, className)}
      title={tooltip}
      data-testid={testId}
    >
      Context: {label}
    </Badge>
  );
}

export default ContextInfluenceBadge;
